/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useReducer} from 'react';
import EmptyTwoStep from "./empty_two_step";
import VerifyPassword from "./verify_password";
import InitAuthAppSetup from "./setup_dialog/init_auth_app_setup";
import InitSmsSetup from "./setup_dialog/init_sms_setup";
import SetupAuthApp from "./setup_dialog/setup_auth_app";
import ManageTwoStep from "./manage_two_step";
import AddPhoneWizard from "./setup_dialog/add_phone_wizard";
import {getLocalUser} from "../../../../service/user";
import DisableTwoStep from "./setup_dialog/disable_two_step";
import RemovePhoneDialog from "./setup_dialog/remove_phone_dialog";
import ShowSigninAgainDialog from "../../../common/modal_dialog/show_signin_again_dialog";
import InitQnapAuthAppSetup from "./qnap_auth_app/init_qnap_auth_app_setup";
import InstallQnapAuthApp from "./qnap_auth_app/install_qnap_auth_app";
import ScanQrCode from "./qnap_auth_app/scan_qr_code";
import QnapAuthAppApproval from "./qnap_auth_app/qnap_auth_app_approval";
import BindQnapAuthAppSuccess from "./qnap_auth_app/bind_qnap_auth_app_success";
import ManageSetupDialog from "./qnap_auth_app/qnap_auth_manager/manage_setup_dialog";
import QnapAuthSetupSuccess from "./qnap_auth_app/qnap_auth_manager/qnap_auth_setup_success";
import {qnapAuthReducer, initState} from "../../../../service/qnap_auth_reducer";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../../service/api";


function TwoStepVerification(props) {
    const [state, dispatch] = useReducer(qnapAuthReducer, initState);
    const currentUser = getLocalUser();

    const onBackMutation = useMutation({
        mutationFn: async () => await apiPost('/ajax/qnap_auth/cancel', null)
    });

    const onQnapAuthCancel = () => {
        onBackMutation.mutate();
        dispatch({type: 'toggleShowQrCodeScan', value: false});
    }

    return (
        <>
            {(!currentUser?.secure || !currentUser?.secure?.two_step_enabled) && <EmptyTwoStep dispatch={dispatch}/>}

            {currentUser?.secure && currentUser?.secure?.two_step_enabled === true && <ManageTwoStep dispatch={dispatch} state={state}/>}

            {state.showVerifyPassword && <VerifyPassword showModal={state.showVerifyPassword} closeModal={()=>dispatch({type: 'toggleVerifyPassword', value: false})} dispatch={dispatch} state={state}/>}
            {state.showInitAppSetup && <InitAuthAppSetup showModal={state.showInitAppSetup} closeModal={()=>dispatch({type: 'toggleShowInitSetup', value: false})} dispatch={dispatch}/>}
            {state.showInitSMSSetup && <InitSmsSetup showModal={state.showInitSMSSetup} closeModal={()=>dispatch({type: 'toggleShowInitSMSSetup', value: false})} dispatch={dispatch}/>}
            {state.showAuthAppSetup && <SetupAuthApp showModal={state.showAuthAppSetup} closeModal={()=>dispatch({type: 'toggleShowAuthAppSetup', value: false})} dispatch={dispatch}/>}
            {state.showAddPhone && <AddPhoneWizard dispatch={dispatch} state={state}/>}
            {state.showDisableDialog && <DisableTwoStep showModal={state.showDisableDialog} closeModal={()=>dispatch({type: 'toggleDisable', value: false})} dispatch={dispatch} />}
            {state.showRemoveMethod && <RemovePhoneDialog showModal={state.showRemoveMethod} closeModal={()=>dispatch({type: 'toggleRemoveMethod', value: false})} dispatch={dispatch} state={state}/>}
            {state.showSigninAgain && <ShowSigninAgainDialog showModal={state.showSigninAgain} closeModal={()=>dispatch({type: 'toggleSigninAgain', value: false})} />}

            {state.showInitQnapAuthAppSetup && <InitQnapAuthAppSetup showModal={state.showInitQnapAuthAppSetup} closeModal={()=>dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: false})} dispatch={dispatch} state={state} />}
            {state.showInstallApp && <InstallQnapAuthApp showModal={state.showInstallApp} closeModal={()=>dispatch({type: 'toggleShowInstallApp', value: false})} dispatch={dispatch} state={state}/>}
            {state.showQrCodeScan && <ScanQrCode showModal={state.showQrCodeScan} closeModal={onQnapAuthCancel} dispatch={dispatch} state={state}/>}
            {state.showApproval && <QnapAuthAppApproval showModal={state.showApproval} closeModal={()=>dispatch({type: 'toggleShowApproval', value: false})} dispatch={dispatch} state={state}/>}
            {state.showSuccess && <BindQnapAuthAppSuccess showModal={state.showSuccess} closeModal={()=>dispatch({type: 'toggleShowSuccess', value: false})} dispatch={dispatch} state={state}/>}

            {state.showManageSetup && <ManageSetupDialog showModal={state.showManageSetup} closeModal={()=>dispatch({type: 'toggleManageSetup', value: false})} dispatch={dispatch} state={state} />}
            {state.showQnapAuthSetupSuccess && <QnapAuthSetupSuccess showModal={state.showQnapAuthSetupSuccess} closeModal={() => dispatch({type: 'toggleQnapAuthSetupSuccess', value: false})} dispatch={dispatch} state={state} />}
        </>
    );
}

export default TwoStepVerification;